import { createContext, useContext } from "react";
import type { ApiClient } from "./client";

export const ApiClientContext = createContext<ApiClient | null>(null);

export function useApiClient(): ApiClient {
  const c = useContext(ApiClientContext);
  if (c === null) throw new Error("useApiClient must be used inside <ApiClientContext.Provider>");
  return c;
}
